import { useCallback, useRef } from 'react'

import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";
import styled from '@emotion/styled'

const StyledImage = styled.img`
  height: 100dvh;
  width: 100dvw;
  object-fit: contain;
`

const ZoomableImage = ({ src, ...rest }) => {
  const imgRef = useRef()

  const onUpdate = useCallback(({ x, y, scale }) => {
    const { current: img } = imgRef
    if (img) {
      const value = make3dTransformValue({ x, y, scale })
      img.style.setProperty("transform", value)
    }
  }, [])

  return (
    <QuickPinchZoom
      draggableUnZoomed={false}
      onUpdate={onUpdate}>
      <StyledImage
        onContextMenu={e => e.preventDefault()}
        ref={imgRef}
        src={src}
        {...rest}
      />
    </QuickPinchZoom>
  )
}

export { ZoomableImage }
